import React from "react";
import resumeFile from "../documents/resume.pdf";

const Resume = () => {
  const skillGroups = [
    {
      title: "Product delivery",
      items: "Requirements, architecture, hands-on development, QA, deployment, and handover",
    },
    {
      title: "Backend and data",
      items: "TypeScript, Node.js, Python, Django, REST APIs, GraphQL, PostgreSQL, MongoDB, Redis, Socket.IO, MQTT",
    },
    {
      title: "Web and mobile",
      items: "React, Next.js, JavaScript, Swift/iOS, Flutter, product UI delivery, and app integrations",
    },
    {
      title: "Technical leadership",
      items: "Roadmaps, code review, team coordination, CI/CD, documentation, and client-facing delivery",
    },
  ];

  return (
    <section id="resume" className="section">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Resume</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-3 wow fadeInUp">Capabilities that support delivery</h2>
        <p className="text-muted text-center text-5 mb-5 wow fadeInUp">
          Tools are selected for the project; the goal is a dependable solution that can be maintained and extended.
        </p>

        <div className="row gy-4">
          {skillGroups.map((group) => (
            <div className="col-md-6 wow fadeInUp" key={group.title}>
              <div className="border rounded p-4 h-100">
                <h3 className="text-5 fw-600 mb-3">{group.title}</h3>
                <p className="text-muted mb-0">{group.items}</p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-muted text-center">
          Download the resume for the full academic and professional history.
        </p>
        <p className="text-center mt-5 wow fadeInUp">
          <a className="btn btn-dark rounded-5 smooth-scroll mt-3" href={resumeFile} download>
            Download resume
          </a>
        </p>
      </div>
    </section>
  );
};

export default Resume;
